import React from 'react';
import ReactDOM from 'react-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight, faTimes } from '@fortawesome/free-solid-svg-icons';
import '../../styles/services/ServicesGalleryModal.css';

const THUMB_WINDOW_SIZE = 5;

const ServicesGalleryModal = ({ images, currentIndex, onClose, onChangeIndex }) => {
  const [thumbStartIndex, setThumbStartIndex] = React.useState(0);
  
  React.useEffect(() => {
    if (currentIndex < thumbStartIndex) {
      setThumbStartIndex(currentIndex);
    } else if (currentIndex >= thumbStartIndex + THUMB_WINDOW_SIZE) {
      setThumbStartIndex(currentIndex - THUMB_WINDOW_SIZE + 1);
    }
  }, [currentIndex, thumbStartIndex]);

  if (!images || images.length === 0) return null;

  const maxThumbStart = Math.max(0, images.length - THUMB_WINDOW_SIZE);
  const showThumbNav = images.length > THUMB_WINDOW_SIZE;

  const prevThumbWindow = (e) => {
    e.stopPropagation();
    setThumbStartIndex((prev) => Math.max(0, prev - THUMB_WINDOW_SIZE));
  };
  
  const nextThumbWindow = (e) => {
    e.stopPropagation();
    setThumbStartIndex((prev) => Math.min(maxThumbStart, prev + THUMB_WINDOW_SIZE));
  };

  const visibleThumbs = images.slice(thumbStartIndex, thumbStartIndex + THUMB_WINDOW_SIZE);

  const prevImage = (e) => {
    e.stopPropagation();
    onChangeIndex(currentIndex === 0 ? images.length - 1 : currentIndex - 1);
  };

  const nextImage = (e) => {
    e.stopPropagation();
    onChangeIndex(currentIndex === images.length - 1 ? 0 : currentIndex + 1);
  };

  const handleThumbnailClick = (idx, e) => {
    e.stopPropagation();
    onChangeIndex(idx);
  };

  const modalContent = (
    <div className="services-gallery-modal__overlay" onClick={onClose}>
      <div className="services-gallery-modal__content" onClick={e => e.stopPropagation()}>
        <button className="services-gallery-modal__close" onClick={onClose} aria-label="Close gallery">
          <FontAwesomeIcon icon={faTimes} />
        </button>
        <button className="services-gallery-modal__arrow left" onClick={prevImage} aria-label="Previous image">
          <FontAwesomeIcon icon={faChevronLeft} />
        </button>
        <div className="services-gallery-modal__main-image">
          <img src={images[currentIndex]} alt={`Services gallery image ${currentIndex + 1}`} />
        </div>
        <button className="services-gallery-modal__arrow right" onClick={nextImage} aria-label="Next image">
          <FontAwesomeIcon icon={faChevronRight} />
        </button>
        <div className="services-gallery-modal__thumbnails">
          {showThumbNav && (
            <button className="services-gallery-modal__thumb-arrow left" onClick={prevThumbWindow} disabled={thumbStartIndex === 0} aria-label="Previous thumbnails">
              <FontAwesomeIcon icon={faChevronLeft} />
            </button>
          )}
          {visibleThumbs.map((img, idx) => {
            const realIdx = thumbStartIndex + idx;
            return (
              <div
                key={realIdx}
                className={`services-gallery-modal__thumbnail${realIdx === currentIndex ? ' active' : ''}`}
                onClick={(e) => handleThumbnailClick(realIdx, e)}
              >
                <img src={img} alt={`Services gallery thumbnail ${realIdx + 1}`} />
              </div>
            );
          })}
          {showThumbNav && (
            <button className="services-gallery-modal__thumb-arrow right" onClick={nextThumbWindow} disabled={thumbStartIndex === maxThumbStart} aria-label="Next thumbnails">
              <FontAwesomeIcon icon={faChevronRight} />
            </button>
          )}
        </div>
      </div>
    </div>
  );

  return ReactDOM.createPortal(modalContent, document.body);
};

export default ServicesGalleryModal; 